<template>
  <div>
    <Dropdown  trigger="click" @on-click="make">
<!--      <a href="javascript:void(0)" :style="{color: `#fff`}">-->
<!--        生成-->
<!--        <Icon :size="18" type="md-arrow-dropdown" color="#FFF" />-->
<!--      </a>-->
<!--      <DropdownMenu slot="list">-->
<!--        <DropdownItem :name="0">新澳门</DropdownItem>-->
<!--        <DropdownItem :name="2">老澳门</DropdownItem>-->
<!--        <DropdownItem :name="1">香港</DropdownItem>-->
<!--        <DropdownItem :name="3">新加坡</DropdownItem>-->
<!--        <DropdownItem :name="4">柬埔寨</DropdownItem>-->
<!--        <DropdownItem :name="5">台湾</DropdownItem>-->
<!--        <DropdownItem :name="6">印尼</DropdownItem>-->
<!--        <DropdownItem :name="7">马来西亚</DropdownItem>-->
<!--        <DropdownItem :name="100">图库</DropdownItem>-->
<!--        <DropdownItem :name="200">全年资料</DropdownItem>-->
<!--        <DropdownItem :name="300">一肖中特</DropdownItem>-->
<!--      </DropdownMenu>-->
    </Dropdown>
<!--    <Dropdown trigger="click" @on-click="selectLang">-->
<!--      <a href="javascript:void(0)" :style="{color: `#fff`}">-->
<!--        {{ title }}-->
<!--        <Icon :size="18" type="md-arrow-dropdown" color="#FFF" />-->
<!--      </a>-->
<!--      <DropdownMenu slot="list">-->
<!--        <DropdownItem v-for="(value, key) in localList" :name="key" :key="`lang-${key}`">{{ value }}</DropdownItem>-->
<!--      </DropdownMenu>-->
<!--    </Dropdown>-->
  </div>
</template>

<script>
import {
  urlGet,
  urlEdit,
  customPost
} from '@/api/Lhc/Lhc'

export default {
  name: 'Language',
  props: {
    lang: String
  },
  data () {
    return {
      langList: {
        'zh-CN': '语言',
        'zh-TW': '語言',
        'en-US': 'Lang'
      },
      localList: {
        'zh-CN': '中文简体',
        'zh-TW': '中文繁体',
        'en-US': 'English'
      }
    }
  },
  watch: {
    lang (lang) {
      this.$i18n.locale = lang
    }
  },
  computed: {
    title () {
      return this.langList[this.lang]
    }
  },
  methods: {
    make(type) {
      customPost('Lhc/make', {type:type}).then(response => {
        this.$Message.success(response.data.msg)
      })
    },
    selectLang (name) {
      this.$emit('on-lang-change', name)
    }
  }
}
</script>
